import { render, staticRenderFns } from "./DataSetComponent.vue?vue&type=template&id=27668f0e&scoped=true&"
import script from "./DataSetComponent.vue?vue&type=script&lang=js&"
export * from "./DataSetComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataSetComponent.vue?vue&type=style&index=0&id=27668f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27668f0e",
  null
  
)

export default component.exports